import React, { createContext, useContext, useEffect } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import { Plus } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { appTools, cn } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import { ComparisonTool, MigrateDefinitions, MigrateTemplates } from ".";

const DevtoolsContext = createContext({})
export const useDevtoolsCtx = () => useContext(DevtoolsContext)

const tools = [
  { id: "migrate-templates", title: "Template Migrator" },
  { id: "migrate-definitions", title: "Migrate Definitions" }
]

export default function DevtoolsProvider({ className="" }:{ className?:string }){
  const navigate = useNavigate()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const [ currentTool, setCurrentTool ] = React.useState<string>()
  
  // const saveFn = appTools1.resource.save(["client.all"])
  
  // const saveClient = () => {
  //   saveFn.mutate({ resource: "client", data: _Client._id } )
  // }

  return (
    <DevtoolsContext.Provider value={{ }}>
      <div className={cn("w-full pt-6", className)}>
        <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="devtools" />

        <div className="w-full flex flex-wrap gap-10">

          <div 
            onClick={() => navigate("/devtools/migrator")}
            className="w-56 h-36 p-4 flex flex-col justify-center items-center border border-solid border-slate-700 cursor-pointer"
          >
            <h3 className="text-xl mb-2">Template Migrator</h3>
            <p className="text-sm">Move templates from v2 to v3</p> 
          </div>

          <div 
            onClick={() => navigate("/devtools/comparison")}
            className="w-56 h-36 p-4 flex flex-col justify-center items-center border border-solid border-slate-700 cursor-pointer"
          >
            <h3 className="text-xl mb-2">Comparison Tool</h3>
            <p className="text-sm text-center">Compare template output between v2 and v3</p> 
          </div>

          <div 
            onClick={() => navigate("/devtools/conditionalupdate")}
            className="w-56 h-36 p-4 flex flex-col justify-center items-center border border-solid border-slate-700 cursor-pointer"
          >
            <h3 className="text-xl mb-2">Conditional Update</h3>
            <p className="text-sm text-center">Update conditional statements across multiple templates.</p> 
          </div>

          <div 
            onClick={() => navigate("/devtools/coderunner")}
            className="w-56 h-36 p-4 flex flex-col justify-center items-center border border-solid border-slate-700 cursor-pointer"
          >
            <h3 className="text-xl mb-2">CodeRunner</h3>
            <p className="text-sm text-center">Runs specific code snippets.</p> 
          </div>
          
        </div>
    
      </div>
    </DevtoolsContext.Provider>
  )
}